import { useState } from 'react';
import { MapComponent } from './Components/Map';
import ColorLegend from './Components/Map/Components/ColorLegend';

import './index.scss';

export const StateResearch = () => {
  const [showOnlyZorbaBuyers, setShowOnlyZorbaBuyers] = useState(false);

  return (
    <div className="state-research-page">
      <div className="map-list-container">
        <div className="map-container">
          <MapComponent showOnlyZorbaBuyers={showOnlyZorbaBuyers} />
        </div>
        <ColorLegend
          showOnlyZorbaBuyers={showOnlyZorbaBuyers}
          setShowOnlyZorbaBuyers={setShowOnlyZorbaBuyers}
        />
      </div>
    </div>
  );
};
